import { SimpleObject } from "../types";

export const transformUpdateRequest = <T>(
    data: T,
    headers: SimpleObject<string>
): T => {
    headers["Content-Type"] = "application/merge-patch+json";
    return data;
};
